import script from "./SelecaoDedo.vue?vue&type=script&setup=true&lang=js"
export * from "./SelecaoDedo.vue?vue&type=script&setup=true&lang=js"

import "./SelecaoDedo.vue?vue&type=style&index=0&id=3364d256&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3364d256"]])

export default __exports__